export const TOGGLE_NAV = "TOGGLE_NAV";
export const SAVE_LIST = "SAVE_LIST"
export const DETAIL_MOVIES = "DETAIL_MOVIES";
export const GET_UPCOMING = "GET_UPCOMING";
export const GET_POPULAR = "GET_POPULAR";
export const GET_NOWPLAYING = "GET_NOWPLAYING";
export const GET_TOP_RATED = "GET_TOP_RATED";
export const GET_DETAILS = "GET_DETAILS";
export const GET_REVIEWS = "GET_REVIEWS";
export const GET_GENRES = "GET_GENRES";
export const GET_TRAILERS = "GET_TRAILERS";
export const GET_MOVIE_CREDITS = 'GET_MOVIE_CREDITS';

export const GET_REQUEST_TOKEN = 'GET_REQUEST_TOKEN';
export const GET_SESSION = 'GET_SESSION';
export const DELETE_SESSION = 'DELETE_SESSION';
export const GET_GUEST_SESSION = 'GET_GUEST_SESSION';
export const TOGGLE_LOG_IN_STATUS = 'TOGGLE_LOG_IN_STATUS';
export const GET_USER_DETAILS = 'GET_USER_DETAILS';

export const POST_MOVIES_NOWPLAYING = 'POST_MOVIES_NOWPLAYING'
export const POST_MOVIES_POPULAR = 'POST_MOVIES_POPULAR'
export const POST_MOVIES_TOP_RATED = 'POST_MOVIES_TOP_RATED';
export const POST_MOVIES_UPCOMING = 'POST_MOVIES_UPCOMING';

export const POST_MOVIE_GENRES = 'POST_MOVIE_GENRES';
export const SET_ITEM_TYPE_MOVIE = 'SET_ITEM_TYPE_MOVIE';
export const SET_ITEM_TYPE_TV = 'SET_ITEM_TYPE_TV';
export const GET_DISCOVER = 'GET_DISCOVER';
export const SEARCH_DATA = 'SEARCH_DATA';
export const POST_SEARCH_RESULTS = 'POST_SEARCH_RESULTS';

export const GET_SEATS = 'GET_SEATS';
export const GET_MOVIES = 'GET_MOVIES';
export const GET_TIMES = 'GET_TIMES';

export const GET_PEOPLE_DETAILS = 'GET_PEOPLE_DETAILS';
export const GET_PEOPLE_COMBINED_CREDITS = 'GET_PEOPLE_COMBINED_CREDITS';
export const GET_PEOPLE_POPULAR = 'GET_PEOPLE_POPULAR';

export const SET_SEARCH = 'SET_SEARCH'
export const SET_CURRENT = 'SET_CURRENT'
export const SET_IS_PLAYING = 'SET_IS_PLAYING'
export const ADD_FAVORITES = 'ADD_FAVORITES'
export const SET_VIEWING_HISTORY = 'SET_VIEWING_HISTORY'
export const SET_MOVIES = "SET_MOVIES"